import { isSegmentOp } from './isSegmentOp';
import type { Clause } from './types';

export function isSegmentClause(clause: Clause) {
  return isSegmentOp(clause.op);
}
